/**
 * Prepared vs Filed's words (B-12a): the section names, the sentence for what the filed
 * return carries and this comparison does not reconcile, and what an exception row is
 * called. Kept out of the route so the words are tested on their own.
 */

export const SECTION_LABELS: Record<string, string> = {
  b2b: 'B2B — 4A, 4B, 4C, 6B, 6C',
  b2cs: 'B2C (Others) — 7',
  b2cl: 'B2C (Large) — 5',
  cdnr: 'Credit/Debit Notes — 9B',
  cdnur: 'Credit/Debit Notes, unregistered — 9B',
  nil: 'Nil rated, exempt and non-GST — 8',
  at: 'Advances received — 11A',
  txpd: 'Advances adjusted — 11B',
  // B-02 compares Table 6A (`filed._COMPARABLE` gained `exp`); until 2026-10-09 the screen still
  // listed it as not compared and printed an export difference as `EXP` (N23).
  exp: 'Exports — 6A',
  hsn: 'HSN Summary — 12',
  supeco: 'Supplies through an e-commerce operator — 14',
}

/** Sections the filed return carries and this comparison reads but does not reconcile.
 *  Table 11 left this list with B-12a, and Table 6A with N23: both are compared. */
export const NOT_COMPARED_LABELS: Record<string, string> = {
  doc_issue: 'Table 13 document series',
}

export function sectionLabel(section: string): string {
  return SECTION_LABELS[section] ?? section.toUpperCase()
}

export function notComparedSentence(counts: Record<string, number> | undefined): string | null {
  const parts = Object.entries(counts ?? {})
    .filter(([, n]) => n > 0)
    .map(
      ([section, n]) =>
        `${n} ${NOT_COMPARED_LABELS[section] ?? `amended rows (${section.toUpperCase()})`}`,
    )
  if (parts.length === 0) return null
  return (
    `The filed return also carries ${parts.join(', ')}. These are read and counted, ` +
    'not compared: this app does not prepare those tables yet.'
  )
}

/** What an exception row is called. A Table 11 row has no document number — its key is
 *  `27@18` — so the service's sentence stands in for it. */
export function exceptionDocText(row: Record<string, unknown>): string {
  if (typeof row.words === 'string' && row.words) return row.words
  return String(row.doc_no ?? '—')
}
